import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeGuard } from '../guards/home.guard';
import { TokenResolver } from '../resolvers/token.resolver';
import { HomePage } from './home.page';

const routes: Routes = [
  {
    path: 'home',
    component: HomePage,
    resolve: {
      token: TokenResolver,
    },
    children: [
      {
        path: 'feed',
        canActivate: [HomeGuard],
        loadChildren: () =>
          import('../pages/feed/feed.module').then((m) => m.FeedPageModule),
      },
      {
        path: 'wallet',
        canActivate: [HomeGuard],
        loadChildren: () =>
          import('../pages/wallet/wallet.module').then(
            (m) => m.WalletPageModule
          ),
        data: {
          preload: true,
        },
      },
      {
        path: 'settings',
        canActivate: [HomeGuard],
        loadChildren: () =>
          import('../pages/settings/settings.module').then(
            (m) => m.SettingsPageModule
          ),
      },
      {
        path: '',
        redirectTo: '/home/feed',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomePageRoutingModule {}
